var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / _Other / Circle / Warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-_Other-/-Circle-/-Warning",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C17.5396995,0 18.9566389,0.833389728 19.6950428,2.17328333 L19.6950428,2.17328333 L31.4854929,23.8237092 C32.1973173,25.1173908 32.1688438,26.6873764 31.4105703,27.9548361 C30.6522967,29.2222958 29.2765132,29.999536 27.7904501,30 L27.7904501,30 L4.20954992,30 C2.72348681,29.999536 1.34770326,29.2222958 0.589429731,27.9548361 C-0.168843795,26.6873764 -0.197317258,25.1173908 0.514507076,23.8237092 L0.514507076,23.8237092 L12.3049572,2.17328333 C13.0433611,0.833389728 14.4603005,0 16,0 Z M16,23 C15.4477153,23 15,23.4477153 15,24 C15,24.5522847 15.4477153,25 16,25 C16.5522847,25 17,24.5522847 17,24 C17,23.4477153 16.5522847,23 16,23 Z M16,7 C15.4477153,7 15,7.44771525 15,8 L15,8 L15,20 C15,20.5522847 15.4477153,21 16,21 C16.5522847,21 17,20.5522847 17,20 L17,20 L17,8 C17,7.44771525 16.5522847,7 16,7 Z",
    id: "Combined-Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warning-circle.c54a3af84606c25fbe062a88209d800f.svg";
export { ForwardRef as ReactComponent };